import { SurveySmartInsightsPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import { useSurveyActions } from 'modules/engagement_surveys/hooks/useSurveyActions'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

export default function SurveySmartInsightsPage() {
  const { surveyId } = useStrictParams<'surveyId'>()
  const { data, loading, error } = useQuery(SurveySmartInsightsPageDocument, {
    variables: { surveyId: Number(surveyId) },
  })
  const formId = data?.surveys.survey?.form.id.toString() || ''
  const { handleActionClick } = useSurveyActions({ formId })

  return (
    <ResponsivePage.Body loading={loading} error={error} onActionClick={handleActionClick}>
      SurveySmartInsightsPage
    </ResponsivePage.Body>
  )
}
